import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { cn } from "../utils";
import { typography } from "../tokens";
import { Panel } from "../panel";
import { IconBox } from "./icon-box";
import { useStableKpiValue } from "../../../utils/useStableKpiValue";

export function StatCard({
  label,
  value,
  sub,
  icon: Icon,
  iconBg = "bg-blue-50",
  iconColor = "text-blue-600",
  change,
  trend = "up",
  neg = false,
  className,
}) {
  const stableValue = useStableKpiValue(value);
  const TrendIcon = trend === "up" ? TrendingUp : TrendingDown;
  const trendColor =
    neg && trend === "up" ? "text-red-600"
    : trend === "up" ? "text-emerald-600"
    : "text-gray-500";

  return (
    <Panel rounded="sm" shadow className={className}>
      <div className="flex items-start justify-between mb-3">
        {Icon && <IconBox icon={Icon} bg={iconBg} color={iconColor} />}
        {change && (
          <div className={cn("flex items-center gap-1", trendColor)} style={{ ...typography.meta }}>
            <TrendIcon className="w-3 h-3" />
            {change}
          </div>
        )}
      </div>
      <p className="text-gray-500" style={typography.statLabel}>{label}</p>
      <p className="text-gray-900 mt-1" style={{ ...typography.statValue, fontVariantNumeric: "tabular-nums" }}>{stableValue}</p>
      {sub && <p className="text-gray-400 mt-1.5" style={typography.statSub}>{sub}</p>}
    </Panel>
  );
}

export function StatGrid({ children, className }) {
  return (
    <div className={cn("grid grid-cols-2 xl:grid-cols-4 gap-4", className)}>
      {children}
    </div>
  );
}
